import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import DependenciesDetail from './DependenciesDetail';
import OptionSetDetail from './OptionSetDetail';
import RequirementForm from './RequirementForm';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;

const Index = () => {
  const { schema } = useEntitySchema(entityNames.REQUIREMENT);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.REQUIREMENT}
      screenQueryName={EDetailsQueryNames.GetRequirementDetails}
      entityId={+id}
      title={data => `Requirement #${data?.id}`}
      cancelLink={AppRoutes.CountryTemplateList}
    >
      <RequirementForm schema={schema} />
      <OptionSetDetail id={+id} />
      <DependenciesDetail id={+id} />
    </S9CustomEntityFormPage>
  );
};
export default Index;
